function getGlobalVar() {
  return function () {
    return globalThis || (1, eval)('this');
  }();
}
export default getGlobalVar;